import React from 'react';
import PropTypes from 'prop-types';

export default function NotEnoughFateWarning({
  currentFate,
  isFree,
  fateCost,
  onGoToBuyFate,
}) {
  if (isFree || currentFate >= fateCost) {
    return null;
  }
  return (
    <div style={{ alignItems: 'center', display: 'flex', justifyContent: 'space-between' }}>
      <span>
        {`Changing your face costs ${fateCost} Fate; you have ${currentFate}.`}
      </span>
      <button
        className="button button--secondary"
        onClick={onGoToBuyFate}
        type="button"
      >
        Buy Fate
      </button>
    </div>
  );
}

NotEnoughFateWarning.propTypes = {
  currentFate: PropTypes.number.isRequired,
  fateCost: PropTypes.number.isRequired,
  isFree: PropTypes.bool.isRequired,
  onGoToBuyFate: PropTypes.func.isRequired,
};